/* eslint-disable */
// @ts-nocheck
import React from 'react';
import Link from '../../../common/components/core/Link';
const FRAUD_RULES_LINK = 'https://docs.branch.io/deep-linked-ads/leveraging-fraud-rules/';

const FraudRulesDocsMessage = () => (
  <div>
    <Link testid="fraud-rules-link" href={FRAUD_RULES_LINK}>
      Learn more
    </Link>{' '}
    about fraud rules and how to enable them.
  </div>
);

export default FraudRulesDocsMessage;
